export type B2B = {
    id: string;
    name: string;
    enabled: boolean;
    liftOperatorId: string;
    beiPassword: string;
    beiUsername: string;
    beiAutoDepot: boolean;
};

export type B2BUserWithCredentials = {
    password: string;
    username: string;
} & B2B;

export const createEmptyB2BUserWithCredentials = (
    liftOperatorId: string
): B2BUserWithCredentials => ({
    id: '',
    name: '',
    enabled: false,
    liftOperatorId,
    beiPassword: '',
    beiUsername: '',
    username: '',
    password: '',
    beiAutoDepot: false,
});
